import { Icon, IconProps } from 'semantic-ui-react'
import icon from './samsung_internet.svg'

export const SamsungInternetIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <img src={icon} alt="Samsung Internet" />
    </Icon>
  )
}

export default SamsungInternetIcon
